import { getDefaultStore } from 'jotai'

import { SelectedDate, SelectedOffer, SelectedPassengers, SelectedPayment, SelectedRoutes } from '@/states/selection.interface'
import {
  confirmingAtom,
  selectedAddonsAtom,
  selectedDateAtom,
  selectedDeparturesAtom,
  selectedOfferAtom,
  selectedPassengersAtom,
  selectedPaymentAtom,
  selectedPetsAtom,
  selectedRoutesAtom,
  selectedVehiclesAtom,
} from '@/states/selectionAtom'

export const wipeSessions = () => {
  const store = getDefaultStore()
  if (typeof window === 'undefined') return () => console.log('Server side')

  store.set(selectedRoutesAtom, {} as SelectedRoutes)
  store.set(selectedVehiclesAtom, { completed: false, trailerCode: undefined, vehicleCode: '' })
  store.set(selectedPassengersAtom, {} as SelectedPassengers)
  store.set(selectedDateAtom, {} as SelectedDate)
  store.set(selectedDeparturesAtom, { departureHome: null, departureOut: null })
  store.set(selectedAddonsAtom, { outboundAddons: [], returnAddons: [] })
  store.set(selectedPaymentAtom, {} as SelectedPayment)
  store.set(selectedOfferAtom, {} as SelectedOffer)
  store.set(selectedPetsAtom, { pets: [], showNumberOfPets: 0 })
  store.set(confirmingAtom, 'CONFIRMING')
  sessionStorage.removeItem('basket')
  sessionStorage.removeItem('purchase-event-tracked')
}
